<template>
  <v-layout
    v-if="parentId && parentId !== '0'"
    elevation-0
    style="background: white;"
  >
    <module-list
      v-if="subtableSelectedId === null && field.canRead"
      :parent-module="moduleName"
      :parent-id="parentId"
      :module-name="field.fieldName"
      :level="level + 1"
      :set-subtable-form-open-module="setSubtableFormOpenModule"
    />
    <module-form
      v-else-if="field.canRead"
      :parent-module="moduleName"
      :parent-id="parentId"
      :id="subtableSelectedId"
      :callback-on-change="itemSaveCallback"
      :level="level + 1"
      :module-name="field.fieldName"
    />
  </v-layout>
</template>

<script>
import sharedComputed from './../../computed'
import sharedMethods from './../../methods'
import formElementProps from './formElementProps'

export default {
  name: 'FormSubtable',

  components: {
    ModuleList: () => import('./../ModuleList'),
    ModuleForm: () => import('./../ModuleForm')
  },

  props: {
    ...formElementProps,

    setSubtableFormOpenModule: {
      type: Function,
      default: () => {}
    },

    level: {
      type: Number,
      default: 0
    },

    parentId: {
      type: String,
      default: null
    }
  },

  watch: {
    parentId (value, before) {
      this.subtableSelectedId = null
    }
  },

  data: () => {
    return {
      subtableSelectedId: null
    }
  },

  computed: {
    ...sharedComputed
  },

  methods: {
    ...sharedMethods
  }
}
</script>
